'use client';

import { ReactNode } from 'react';
import Snackbar from './Snackbar';
import Dialog from './Dialog';
import Form from './Form';
import Banner from './Banner';
import ImageDialog from './Image';

interface NotificationsProps {
  children: ReactNode;
}

export default function Notifications({ children }: NotificationsProps) {
  return (
    <>
      {children}
      <Banner />
      <Snackbar />
      <Dialog />
      <ImageDialog />
      <Form />
    </>
  );
}
